import styled, { css } from "styled-components";

const baseTextStyle = css`
  font-family: 'Segoe UI', sans-serif;
  margin: 0;
`;

const flexColumn = (gap) => css`
  display: flex;
  flex-direction: column;
  gap: ${gap};
`;

const bodyTextStyle = css`
  ${baseTextStyle}
  font-size: 14px;
  line-height: 22px;
`;


export const SupportingDocumentsContainer = styled.div`
  ${flexColumn('30px')}
  padding: 15px 20px 24px 20px;
  background-color: var(--white);
  border: 1px solid #dfdfdf;
  border-radius: 2px;
`;

export const Section = styled.div`
  ${flexColumn('15px')}
`;

export const HeaderSection = styled.div`
  ${flexColumn('8px')}
`;

export const UploadList = styled.div`
  ${flexColumn('16px')}
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
`;


export const Title = styled.h4`
  ${baseTextStyle}
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  color: var(--black1);
`;

export const Description = styled.p`
  ${bodyTextStyle}
  color: var(--lightGray3);
`;

export const FileTypeWarningText = styled.p`
  ${bodyTextStyle}
  font-weight: 600;
  color: var(--error-color);
`;


export const SubmitButton = styled.button`
  ${baseTextStyle}
  background-color: var(--button-color);
  border: 1px solid var(--button-color);
  border-radius: 2px;
  padding: 8px 24px;
  color: var(--white);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;


export const EmptyStateContainer = styled.div`
  ${flexColumn('0')}
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: rgba(215, 222, 232, 0.1);
  border: 1px solid #d7dee8;
  border-radius: 2px;
`;

export const EmptyStateIcon = styled.i`
  font-size: 32px;
  color: var(--highlight-color);
  margin-bottom: 10px;
`;

export const EmptyStateText = styled.p`
  ${bodyTextStyle}
  color: var(--gray1);
`;

export const FileRowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 10px;
  min-height: 59px;
  background-color: var(--white);
  border: 1px solid ${props => props.$isDragOver ? 'var(--highlight-color)' : '#D7DEE8'};
  border-style: ${props => props.$isDragOver ? 'dashed' : 'solid'};
  border-radius: 2px;
  cursor: ${props => props.$clickable && !props.$isUploaded ? 'pointer' : 'default'};
  transition: background-color 0.15s ease, border-color 0.15s ease, border-style 0.15s ease;

  &:hover {
    background-color: ${props => props.$clickable && !props.$isUploaded ? 'var(--hover-color)' : 'var(--active-color)'};
  }

  ${props => props.$isUploaded && `
    background-color: var(--active-color);
  `}

  ${props => props.$isDragOver && `
    background-color: var(--hover-color);
  `}
`;

export const FileRowContent = styled.div`
  ${flexColumn('8px')}
  flex: 1;
`;

export const FileRowLabel = styled.p`
  ${baseTextStyle}
  font-size: 14px;
  line-height: 14px;
  color: var(--lightGray3);
`;

export const FileRowDescription = styled.p`
  ${baseTextStyle}
  font-size: 12px;
  line-height: normal;
  color: var(--gray1);
`;

export const FileRowStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FileRowLink = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;
  ${baseTextStyle}
  font-size: 12px;
  line-height: 12px;
  color: #007bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const FileRowHelper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const FileRowHelperIcon = styled.i`
  color: #c1232c;
  font-size: 12px;
`;

export const FileRowHelperText = styled.p`
  ${baseTextStyle}
  font-size: 12px;
  line-height: 12px;
  color: #c1232c;
`;

export const FileRowHelperBold = styled.span`
  font-weight: bold;
`;

export const FileRowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: var(--button-color, #467fcf);
  border: 1px solid var(--button-color, #467fcf);
  border-radius: 2px;
  padding: 8px 24px;
  height: 34px;
  color: var(--white);
  ${baseTextStyle}
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.15s ease;
:hover{
  background-color: var(--button-hover-color);
  border: 1px solid var(--button-hover-color);
  color: var(--white);
}
:active{
  background-color: var(--button-active-color);
  border: 1px solid var(--button-active-color);
  color: var(--white);
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const FileRowButtonLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color:${props => props.$disabled ? '#acacac' : 'var(--button-color, #467fcf)'}; 
  border: 1px solid ${props => props.$disabled ? '#acacac' : 'var(--button-color, #467fcf)'}; 
  border-radius: 2px;
  padding: 8px 20px;
  height: 33px;
  color: var(--white);
  font-weight: 600;
  font-size: 14px;
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
  white-space: nowrap;
  text-decoration: none;
  opacity: ${props => props.$disabled ? 0.6 : 1};
  pointer-events: ${props => props.$disabled ? 'none' : 'auto'};
:hover{
  background-color: var(--button-hover-color);
  border: 1px solid var(--button-hover-color);
  color: var(--white);
}
:active{
  background-color: var(--button-active-color);
  border: 1px solid var(--button-active-color);
  color: var(--white);
  }
  `;

export const FileRowInput = styled.input`
  display: none;
`;
